import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import { useMarketingStore } from '../../store/marketing.store';
import InfoTooltip from '../revenue/InfoTooltip';

function formatNum(value: number): string {
  return value.toLocaleString('en-US');
}

const SERIES = [
  { key: 'leads', label: 'Lead', color: '#10b981' },
  { key: 'mql', label: 'MQL', color: '#14b8a6' },
  { key: 'opp', label: 'OPP', color: '#8b5cf6' },
  { key: 'customers', label: 'Customer', color: '#ec4899' },
] as const;

export default function FunnelTrendChart({ isDark }: { isDark: boolean }) {
  const funnelTrend = useMarketingStore((s) => s.funnelTrend);

  const tooltipText =
    'Xu hướng chuyển đổi phễu marketing theo ngày.\n\n' +
    'Lead / MQL / OPP / Customer từ HubSpot lifecycle stages.\n' +
    'Hiển thị dạng stacked area chart.';

  if (!funnelTrend || !funnelTrend.length) {
    return (
      <div className={`backdrop-blur rounded-lg p-6 ${isDark ? 'bg-white/10' : 'bg-white border border-gray-200 shadow-sm'}`}>
        <h3 className={`text-lg font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Xu hướng Phễu
          <InfoTooltip isDark={isDark} text={tooltipText} />
        </h3>
        <div className={`flex items-center justify-center h-64 text-sm ${isDark ? 'text-slate-400' : 'text-gray-500'}`}>
          Chưa có dữ liệu
        </div>
      </div>
    );
  }

  return (
    <div className={`backdrop-blur rounded-lg p-6 ${isDark ? 'bg-white/10' : 'bg-white border border-gray-200 shadow-sm'}`}>
      <h3 className={`text-lg font-semibold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
        Xu hướng Phễu
        <InfoTooltip isDark={isDark} text={tooltipText} />
      </h3>

      <ResponsiveContainer width="100%" height={360}>
        <AreaChart data={funnelTrend} margin={{ top: 10, right: 30, left: 20, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={isDark ? '#334155' : '#e5e7eb'} />
          <XAxis
            dataKey="date"
            tick={{ fill: isDark ? '#94a3b8' : '#6b7280', fontSize: 11 }}
            interval={funnelTrend.length > 14 ? Math.ceil(funnelTrend.length / 14) : 0}
          />
          <YAxis
            tick={{ fill: isDark ? '#94a3b8' : '#6b7280', fontSize: 11 }}
            tickFormatter={formatNum}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: isDark ? '#1e293b' : '#ffffff',
              border: `1px solid ${isDark ? '#475569' : '#e5e7eb'}`,
              borderRadius: '8px',
              color: isDark ? '#f8fafc' : '#111827',
            }}
            formatter={(value: any, name: any) => [formatNum(value as number), name]}
            labelStyle={{ color: isDark ? '#f8fafc' : '#111827', fontWeight: 600 }}
          />
          <Legend
            wrapperStyle={{ color: isDark ? '#94a3b8' : '#6b7280', fontSize: 12 }}
          />
          {SERIES.map((s) => (
            <Area
              key={s.key}
              type="monotone"
              dataKey={s.key}
              name={s.label}
              stackId="1"
              stroke={s.color}
              fill={s.color}
              fillOpacity={isDark ? 0.3 : 0.4}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
